
//Note: Important!!!
//import the class here, not the object
import {HttpService} from 'service/HttpService';

import {StockAction} from 'AppAction';

import AppConstants from 'AppConstants';
import Dispatcher from 'service/Dispatcher';

const BASE_URL = AppConstants.BASE_API_URL+"/stock/owner";

class StockOwnerAPI extends HttpService {

    getAllOwners() {
        super.get("/list", response => {
            Dispatcher.dispatch({
				type: StockAction.LOAD_STOCK_OWNERS,
				stockOwners: response.data,
			});
		});
    }


    getStockOwner(ownerName) {
        super.get("/find?ownerAlias="+ownerName, response => {
            Dispatcher.dispatch({
				type: StockAction.LOAD_SINGLE_STOCK_OWNER,
				stockOwner: response.data,
			});
		});
    }
}


export default new StockOwnerAPI(BASE_URL);


// WEBPACK FOOTER //
// ./src/service/api/StockOwnerAPI.js